"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlsFormSalesInfoBoxInput = void 0;
const DOM_1 = require("../../../../../public/js/utils/DOM");
var ControlsFormSalesInfoBoxInput;
(function (ControlsFormSalesInfoBoxInput) {
    class Config {
        static inputContainerClass = "SalesInfoBoxInput";
    }
    class Control {
        static initialize(container) {
            const inputs = DOM_1.DOM.Parser.getHtmlElements(Config.inputContainerClass, container, true);
            for (let i = 0; i < inputs.length; i++) {
                this.initializeElement(inputs[i]);
            }
        }
        static initializeElement(element) {
            const parent = DOM_1.DOM.Parser.getParentElement(element);
            parent.classList.remove('s12', 'm6', 'l4', 'customDesign-forms-field', 'input-field');
        }
    }
    ControlsFormSalesInfoBoxInput.Control = Control;
})(ControlsFormSalesInfoBoxInput || (exports.ControlsFormSalesInfoBoxInput = ControlsFormSalesInfoBoxInput = {}));
